import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'
import { FeatureToggle } from './featureToggles'
export const catalogAdminExtractionModelsAccessConfiguration: DomainAccessControlConfig = {
  permissions: Permission.CatalogDetectionViewAccess,
}

export const catalogAdminExtractionModelsEditAccessConfiguration: DomainAccessControlConfig = {
  permissions: [Permission.CatalogDetectionViewAccess, Permission.CatalogDetectionModifyAccess],
}

// Gates the per-version delete action. Must match the permission the GraphQL Mesh enforces for
// the TombstoneStepVersion mutation (catalog_attribute_management_platform.modify); gating on
// catalog_detection.modify instead would show an enabled button to users the Mesh then rejects.
export const attributeManagementPlatformModifyAccessConfiguration: DomainAccessControlConfig = {
  permissions: Permission.AttributeManagementPlatformModifyAccess,
}

export const showCampPipelineEditor: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.ShowCampPipelineEditor],
}

export const showCampAsyncStepPreview: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.ShowCampAsyncStepPreview],
}

export const showSentinelManagedAttributes: DomainAccessControlConfig = {
  featureToggles: [FeatureToggle.ShowSentinelManagedAttributes],
}
